export const FooterBar = () => {
  return (
    <div
      data-testid="footer-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-ink/10 bg-canvas/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-3 md:px-12">
        <a
          href="https://fragosoinvestment.com"
          className="font-accent text-[10px] uppercase tracking-[0.2em] text-ink-soft md:text-xs"
        >
          By Fragoso Investment Group
        </a>
        <span className="hidden font-body text-[11px] leading-none text-ink-soft sm:block md:text-xs">
          Los activos virtuales no son moneda de curso legal en México e
          implican riesgos.
        </span>
      </div>
    </div>
  );
};
